import {
    Chart,
    Filler,
    Legend,
    LineElement,
    PointElement,
    RadialLinearScale,
    Tooltip,
} from 'chart.js';
import { Radar } from 'react-chartjs-2';
import { useColors } from '../../../../hooks/useColors';
import { LabelBodySmall } from '../../components';
import { Rating } from './Rating';

Chart.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
);

type Props = {
    importantAreas: string[];
    ratingsImportance: Rating[];
    ratingsTime: Rating[];
    className?: string;
};
export function Module4Exercise1Graph({
    importantAreas,
    ratingsImportance,
    ratingsTime,
    className,
}: Props) {
    const colors = useColors();
    return (
        <div className="max-w-narrow">
            <Radar
                className={className}
                options={{
                    plugins: {
                        legend: { display: false },
                    },
                    scales: {
                        r: {
                            ticks: {
                                display: false,
                                stepSize: 1,
                            },
                            min: 0,
                            max: 5,
                        },
                    },
                }}
                data={{
                    labels: importantAreas,
                    datasets: [
                        {
                            data: importantAreas.map(
                                (x) =>
                                    ratingsImportance.find((y) => y.name === x)
                                        ?.rating ?? 0,
                            ),
                            backgroundColor: `rgb(from ${colors('dark-red')} r g b / 20%)`,
                            borderWidth: 1,
                            borderColor: colors('dark-red'),
                            pointStyle: false,
                        },
                        {
                            data: importantAreas.map(
                                (x) =>
                                    ratingsTime.find((y) => y.name === x)
                                        ?.rating ?? 0,
                            ),
                            backgroundColor: `rgb(from ${colors('vibrant-blue')} r g b / 20%)`,
                            borderWidth: 1,
                            borderColor: colors('vibrant-blue'),
                            pointStyle: false,
                        },
                    ],
                }}
            />
            <div className="flex justify-center">
                <LabelBodySmall>
                    <span className="mr-10 inline-block h-10 w-10 rounded-full bg-dark-red" />
                    Hvad er vigtigt?
                </LabelBodySmall>
                <LabelBodySmall className="ml-20">
                    <span className="mr-10 inline-block h-10 w-10 rounded-full bg-vibrant-blue" />
                    Hvor bruger du tid?
                </LabelBodySmall>
            </div>
        </div>
    );
}
